import remove from 'lodash/remove';
import { SET_LOADER, REMOVE_LOADER } from '../actions/types';

export default (state = [], action) => {
	switch (action.type) {
		case SET_LOADER:
			return [...state, action.payload];
    case REMOVE_LOADER: {
      const newState = [...state];
      remove(newState, n => n === action.payload);
      return newState;
    }
		default:
			return state;
	}
};
